import moment, { Moment } from 'moment';
const TOTAl_DAYS = 42;
export const getDaysOfMonth = (year: number, month: number) => {
  let firstDayOfMonth = moment(`${year}-${month}-1`);
  let lastDayOfMonth = moment(`${year}-${month + 1}-1`).subtract(1, 'day');
  // 开始补全第一天前的日期
  while (firstDayOfMonth.day() !== 0) {
    firstDayOfMonth = firstDayOfMonth.subtract(1, 'day');
  }

  // 开始补全最后一天后的日期
  while (lastDayOfMonth.day() !== 6) {
    lastDayOfMonth = lastDayOfMonth.add(1, 'day');
  }

  const totalDatys = lastDayOfMonth.diff(firstDayOfMonth, 'days') + 1;
  if (totalDatys < TOTAl_DAYS) {
    const diffCount = TOTAl_DAYS - totalDatys;
    // 继续倒退时间
    lastDayOfMonth = lastDayOfMonth.add(diffCount, 'day');
  }

  const days = [];
  let tempDate = firstDayOfMonth;
  while (tempDate.isBefore(lastDayOfMonth) || tempDate.isSame(lastDayOfMonth)) {
    days.push(tempDate);
    tempDate = tempDate.add(1, 'day');
  }

  return days;
};

export const getLatestTime = (time: Moment) => {
  const currentMinutes = time.minute();
  if (currentMinutes % 15 === 0) {
    return time.add(15,'minutes');
  }
  const target = Math.ceil(currentMinutes / 15) * 15 - currentMinutes;
  return time.add(target, 'minutes');
};
